export const IconReport = ({ size = 28 }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={`${size}px`} height={`${size}px`} viewBox="0 0 256 256">
			<g>
				<g>
					<polygon
						fill="#212121"
						points="85.13 188.44 59.35 188.44 59.35 44.07 172.87 44.07 172.87 69.52 168.87 69.52 168.87 48.07 63.35 48.07 63.35 184.44 85.13 184.44 85.13 188.44"
					/>
					<path fill="#212121" d="M196.65,211.93H83.13V67.56H196.65Zm-109.52-4H192.65V71.56H87.13Z" />
					<rect fill="#212121" x="140.43" y="88.57" width="32.77" height="4" />
					<rect fill="#212121" x="140.43" y="108.24" width="32.77" height="4" />
					<rect fill="#212121" x="140.43" y="127.91" width="32.77" height="4" />
					<rect fill="#212121" x="107.66" y="147.58" width="65.54" height="4" />
					<rect fill="#212121" x="107.66" y="167.26" width="65.54" height="4" />
					<rect fill="#212121" x="107.66" y="186.93" width="65.54" height="4" />
					<path
						fill="#212121"
						d="M130.72,117c0,4.66-3.28,7.94-8.83,8.38v5.53h-3.06v-5.58a15.92,15.92,0,0,1-9.34-4.48l2.39-2.85a13,13,0,0,0,8.81,3.79c3.37,0,5.86-1.67,5.86-4.55,0-3.28-2.63-4.37-6.85-5.69-5-1.61-9.54-3.17-9.54-8.61,0-4.44,3.1-7.8,8.68-8.07V89.08h3.05v6a18.68,18.68,0,0,1,7.78,3.32l-2.3,2.83a14.18,14.18,0,0,0-7.69-2.7c-3.19,0-5.42,1.49-5.42,4.17,0,2.85,2.77,3.9,6.58,5.15,5.62,1.78,9.88,3.28,9.88,9.14Z"
					/>
				</g>
			</g>
		</svg>
	);
};
